<div class="radio-group">
	<nz-radio-group [(ngModel)]="ssmlMode" (ngModelChange)="onSsmlModeChange($event)">
		<label nz-radio-button [nzValue]="SsmlMode.OFF">Text</label>
		<label nz-radio-button [nzValue]="SsmlMode.ON">SSML</label>
	</nz-radio-group>
</div>

<form nz-form [formGroup]="form" [ngClass]="[ssmlMode === SsmlMode.ON ? 'ssml-mode' : '']">
	<app-azure-voices-dropdown-field
		[label]="'Voice'"
		[controlName]="'voice'"
		[placeholder]="'Select voice'"
		[required]="form.get('voice')?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-decimal-field
		[label]="'Prosody'"
		[controlName]="'prosody'"
		[placeholder]="'Enter prosody value'"
		[required]="form.get('prosody')?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-textarea-field
		[label]="'Text'"
		[controlName]="'text'"
		[placeholder]="'Enter text to generate audio'"
		[required]="form.get('text')?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
		[rows]="15"
	/>

	<nz-form-item>
		<nz-form-control [nzOffset]="7" [nzSpan]="12">
			<div class="buttons">
				<button
					nz-button
					nzType="primary"
					[disabled]="loading() || form.invalid"
					(click)="onSubmitSingleClick()"
				>
					Generate Single
					@if (loadingSingle()) {
						<nz-spin nzSimple nzSize="small"></nz-spin>
					}
				</button>

				@if (ssmlMode === SsmlMode.OFF) {
					<button
						nz-button
						nzType="primary"
						[disabled]="loading() || form.invalid"
						(click)="onSubmitBatchClick()"
					>
						Generate Batch
						@if (loadingBatch()) {
							<nz-spin nzSimple nzSize="small"></nz-spin>
						}
					</button>
				}

				<button nz-button (click)="onClearClicked()">Clear</button>
			</div>
		</nz-form-control>
	</nz-form-item>
</form>
